import * as Sentry from '@sentry/astro'
import { getEnvironmentFlags } from './scripts/lib/environment.js'

const { isProd, vercelEnvironment } = getEnvironmentFlags({
	vercelEnvironment: import.meta.env.PUBLIC_VERCEL_ENV,
	isDevelopment: import.meta.env.DEV,
	sourceName: 'PUBLIC_VERCEL_ENV',
})

Sentry.init({
	dsn: 'https://171f048b09c597ae1bef2163695dcfb1@o4508858787299328.ingest.de.sentry.io/4508858959528016',
	enabled: isProd,
	environment: vercelEnvironment,
	tracesSampleRate: isProd ? 0.1 : 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	integrations: [
		Sentry.replayIntegration({
			maskAllText: false,
			blockAllMedia: false,
		}),
	],
})
